import React from 'react';
import { Lock, ShieldCheck, Check, Star, Zap, BarChart3 } from 'lucide-react';
import { useAppContext } from '../../context/AppContext';
import Modal from '../ui/Modal';

const TrialModal = () => {
  const app = useAppContext();
  const isTrial = !app.hasCompletedTrial;

  const features = [
    { icon: Zap, text: 'Live Nasdaq futures signals streamed in real-time' },
    { icon: BarChart3, text: 'Tier-based position sizing for your account' },
    { icon: Star, text: isTrial ? 'Full premium access during your trial' : 'Premium expert analysis and insights' },
  ];

  return (
    <Modal
      isOpen={app.showTrialOfferModal}
      onClose={() => app.setShowTrialOfferModal(false)}
    >
      <div className="trial-modal">
        {/* Top accent bar */}
        <div className="trial-modal__accent" />

        <div className="trial-modal__content">
          <div className="trial-modal__badge-row">
            <div className="trial-modal__badge">
              <span className="trial-modal__badge-dot" />
              {isTrial ? '7-Day Free Trial' : 'Premium Access'}
            </div>
          </div>

          <h2 className="trial-modal__title">
            {isTrial ? 'Try AlphaNQ free for 7 days' : 'Subscribe to AlphaNQ'}
          </h2>

          <div className="trial-modal__pricing">
            <div className="trial-modal__price-row">
              <span className="trial-modal__amount">{isTrial ? '$0' : '$99'}</span>
              <div className="trial-modal__price-meta">
                <span className="trial-modal__price-label">{isTrial ? 'for 7 days' : 'per month'}</span>
                {isTrial && <span className="trial-modal__price-after">then $99/mo</span>}
              </div>
            </div>
          </div>

          <div className="trial-modal__features">
            {features.map((f, i) => (
              <div key={i} className="trial-modal__feature">
                <div className="trial-modal__feature-check">
                  <Check size={14} strokeWidth={3} />
                </div>
                <span>{f.text}</span>
              </div>
            ))}
          </div>

          <button className="trial-modal__cta" onClick={app.handleStartTrial}>
            <Lock size={16} />
            {isTrial ? 'Start Free Trial' : 'Subscribe Now'}
          </button>

          <p className="trial-modal__cancel">
            Cancel anytime. No questions asked.
          </p>
        </div>

        <div className="trial-modal__footer">
          <div className="trial-modal__secure">
            <ShieldCheck size={14} />
            <span>Secured by <strong>Stripe</strong></span>
          </div>
          <p className="trial-modal__legal">
            {isTrial
              ? "You won't be charged until your 7-day trial ends. Cancel anytime before to avoid charges."
              : "You'll be charged $99 today for immediate access. Cancel anytime from your account."}
          </p>
        </div>
      </div>
    </Modal>
  );
};

export default TrialModal;
